import { Action, createReducer, on } from '@ngrx/store';
import { IUserRolesResponse } from '../models/user-roles.model';
import { fromStaticDataUserRolesActions } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';

export const userRolesFeatureKey = 'userRoles';

export interface UserRolesState {
  userRolesResponse: IUserRolesResponse[];
  userRolesFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: UserRolesState = {
  userRolesFailure: undefined,
  userRolesResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataUserRolesActions.loadUserRoles, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromStaticDataUserRolesActions.loadUserRolesSuccess, (state, action) => ({
    ...state,
    userRolesResponse: action.response
  })),

  on(fromStaticDataUserRolesActions.loadUserRolesFailure, (state, action) => ({
    ...state,
    userRolesFailure: action.error
  }))
);

export const getUserRolesResponse = (state: UserRolesState) => state.userRolesResponse;
export const getUserRolesFailure = (state: UserRolesState) => state.userRolesFailure;
export const getUserRolesIsLoaded = (state: UserRolesState) => state.loaded;
